import { render, staticRenderFns } from "./FormPublisher.vue?vue&type=template&id=d4ce15cc"
import script from "./FormPublisher.js?vue&type=script&lang=js&external"
export * from "./FormPublisher.js?vue&type=script&lang=js&external"
import style0 from "./FormPublisher.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports